"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxOption = void 0;

var _primary = require("./primary");

var _secondary = require("./secondary");

var _getRouteComponent = require("../../helpers/getRouteComponent");

var CheckboxOption = (0, _getRouteComponent.getRouteComponent)({
  primary: _primary.PrimaryCheckboxOption,
  secondary: _secondary.SecondaryCheckboxOption
}, 'CheckboxOption');
exports.CheckboxOption = CheckboxOption;